// extracted by mini-css-extract-plugin
export default {"userImageContainer":"profileImage_userImageContainer__dhgJm","large":"profileImage_large__+C25M"};